import { CLASSNAME } from '~/assistant/utils/constants';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  target: HTMLElement;
  [key: string]: any;
};

class Notice {
  props: Props;

  constructor(props: Props) {
    this.props = { ...props };
    this.render();
  }

  template() {
    return /*html*/ `
      <div class="${bem([CLASSNAME, 'notice'])}">
        <p>AI를 통해 자동 생성된 내용으로 방송 내용과 차이가 있을 수 있습니다.</p>
      </div>
    `;
  }

  render() {
    const { target } = this.props;
    target.insertAdjacentHTML('beforeend', this.template());
  }
}

export default Notice;
